module.exports = __webpack_public_path__ + "img/css.64549b8a.svg";